import { storage } from "@gtmhub/core/storage";
import { IGtmhubRootScopeService } from "@gtmhub/models";

interface IExpandNavChangedEventArgs {
  value: boolean;
}

export class ExpandNavV2Service {
  public static $inject = ["$rootScope"];
  private isNavExpanded: boolean;

  constructor(private $rootScope: IGtmhubRootScopeService) {
    this.setInitialValue();
  }

  public setIsNavExpanded(value: boolean): void {
    storage.set("isNavExpanded", value);

    this.isNavExpanded = value;
    this.$rootScope.$broadcast("navV2Expanded", { value });
  }

  public subscribe(callback: (args: IExpandNavChangedEventArgs) => void): void {
    this.$rootScope.$on("navV2Expanded", (evt, args: IExpandNavChangedEventArgs) => callback(args));
  }

  public getCurrentValue(): boolean {
    return this.isNavExpanded;
  }

  private setInitialValue(): void {
    const isNavExpanded = storage.get<boolean>("isNavExpanded");

    if (isNavExpanded === null) {
      storage.set("isNavExpanded", true);
      this.isNavExpanded = true;
    } else {
      this.isNavExpanded = isNavExpanded;
    }
  }
}
